export const EMPTY_FUNCTION = () => void 0;
